var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPwa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 90,
    viewBox: "0 0 149 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13_685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.3124 56.7546L100.105 49.5562H108.168L104.342 38.6367L109.128 26.3L122.835 63.3992H112.726L110.384 56.7546H97.3124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.688 63.3992L103.363 26.3L93.6339 26.3001L83.5956 50.2744L76.4574 26.3001H68.9794L61.3149 50.2744L55.9097 39.3498L51.0182 54.7109L55.9845 63.3992H65.5588L72.4849 41.8994L79.0886 63.3992H88.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4019 50.6637H41.3943C43.2095 50.6637 44.8259 50.4572 46.2434 50.0441L47.7931 45.1775L52.1243 31.576C51.7943 31.0428 51.4175 30.5386 50.994 30.0636C48.7702 27.5545 45.5166 26.3 41.233 26.3H26.1671V63.3992H35.4019V50.6637ZM43.3337 34.8351C44.2024 35.7262 44.6366 36.9187 44.6366 38.4126C44.6366 39.918 44.2547 41.112 43.4908 41.9945C42.6533 42.975 41.1114 43.4653 38.8649 43.4653H35.4019V33.4983H38.8904C40.984 33.4983 42.4652 33.9439 43.3337 34.8351Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13_685",
    x: 0.216963,
    y: 0.35005,
    width: 148.568,
    height: 88.9991,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.975
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_685"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_685",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwa);
export default __webpack_public_path__ + "static/media/pwa.255b0c37ca97f9e177fbd05a66215035.svg";
export { ForwardRef as ReactComponent };